'use strict'

import format from 'string-format'
import session from './session'

export default {

	seq_list() {
		return session.get('seq/')
			.catch(function (error) {
				console.error(format(
					"method: '{method}' url: '{url}'" + "\n" +
					"error: '{error}'.",
					{
						method: error.config.method,
						url: error.config.url,
						error: error.toString()
					}))
			})
	},

	seq_get(seq_id) {
		const get_url = format('seq/{id}/', {id: seq_id})
		return session.get(get_url)
	},

	seq_update(seq) {
		let data = new FormData()

		for (let key in seq) {
			data.append(key, seq[key])
		}

		return session.request({
			method: 'PATCH',
			url: format('seq/{id}', {id: seq.id}),
			headers: {'Content-Type': 'multipart/form-data'},
			data
		})
	},

	seq_create(seq) {
		let data = new FormData()

		for (let key in seq) {
			data.append(key, seq[key])
		}

		return session.request({
			method: 'CREATE',
			url: format('seq'),
			headers: {'Content-Type': 'multipart/form-data'},
			data
		})
	}
}